import { useSelector } from 'react-redux';
import type { TSportsbookConfigs } from 'interfaces/sportsbook-configs';
import { useWidgetConfigs } from 'newelements/Sportsbook/Widgets/hooks/useWidgetConfigs';
import { getSportsbookConfigs } from 'store/selectors/app-data';

function useSportsbookConfigs(): TSportsbookConfigs {
  const separatedWidgetConfigs = useWidgetConfigs();
  const mainConfigs = useSelector(getSportsbookConfigs);

  let sportsbookConfigs: TSportsbookConfigs = mainConfigs;

  if (separatedWidgetConfigs?.pageType !== undefined) {
    sportsbookConfigs = separatedWidgetConfigs as TSportsbookConfigs;
  }

  return sportsbookConfigs;
}

export { useSportsbookConfigs };
